<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {}, 'CREATE')"
        >新增</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%"
      row-key="id"
      border
      lazy
      :load="load"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="parentId" label="父编号" width="180"> </el-table-column>
      <el-table-column prop="id" label="当前编号" width="180"> </el-table-column>
      <el-table-column prop="name" label="名称"> </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
        width="280"
      >
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="checkDialogFormVisible(true, scope.row, 'UPDATE')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="checkDialogFormVisible(true, scope.row, 'CREATE')"
            >创建子菜单</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--    编辑和新增-->
    <el-dialog
      :title="DIALOG_TITLE_TYPE[dialogType]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="地区名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false, {}, '')">取消</el-button>
        <el-button type="primary" @click="saveAddOrEditData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { editRegion, getCascadeRegion } from "@/api/regional";
import { DIALOG_TITLE_TYPE, getValue } from "@/utils/enumUtile";

export default {
  computed: {
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    getValue() {
      return getValue;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      list: [],
      listLoading: true,
      dialogFormVisible: false, // 新增 or 编辑的弹框
      dialogType: "",
      rules: {
        name: [{ required: true, message: "地区名称不能为空", trigger: "change" }]
      },
      form: {
        id: 0,
        parentId: 0,
        name: null
      },
      btnLoading: false
    };
  },
  created() {
    this.onLoad();
  },
  watch: {},
  methods: {
    onLoad() {
      this.getList(0).then(resp => {
        this.list = resp;
      });
    },
    async getList(parentId) {
      this.listLoading = true;
      const params = {
        parentId
      };
      const response = await getCascadeRegion(params);
      const data = response.data || [];
      if (data && data.length !== 0) {
        data.map(item => {
          item.hasChildren = true;
          delete item.children;
        });
      }
      this.listLoading = false;
      return data;
    },
    load(tree, treeNode, resolve) {
      this.getList(tree.id).then(resp => {
        resolve(resp);
      });
    },
    /**
     * 切换状态
     * @param status
     * @param editObj
     * @param type
     */
    checkDialogFormVisible(status, editObj = {}, type) {
      if (type === "CREATE") {
        if (editObj && Object.keys(editObj).length !== 0) {
          this.form.parentId = editObj.id;
        } else {
          this.form.parentId = 0;
        }
      }
      if (status && type === "UPDATE") {
        this.form.id = editObj.id;
        this.form.name = editObj.name;
        this.form.parentId = editObj.parentId;
      }
      if (!status) {
        this.form.id = 0;
        this.form.name = null;
        this.form.parentId = null;
        this.$refs.form.resetFields();
      }
      this.dialogType = type;
      this.dialogFormVisible = status;
    },
    /**
     * 确认添加还是编辑
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.form;
          const params = {
            parentId: form.parentId,
            name: form.name
          };
          if (form.id && form.id !== 0) {
            params.id = form.id;
          }
          this.btnLoading = true;
          editRegion(params)
            .then(() => {
              this.load({ id: form.parentId });
              this.checkDialogFormVisible(false);
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
